module.exports = __webpack_public_path__ + "media/images/logo_transparent-3b965d84d581a4b3690831f2a68e90c0.svg";